import { normalizeLikeBrowser, toSafeHttpUrl } from 'app/shared-components/util/safeHttpUrl';

const ExternalLink = ({ href, children, className = '', maxWidth = '300px' }) => {
    const linkStyles = {
        maxWidth,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline-block',
    };

    // Only an http(s) URL becomes a link. The value is user-supplied (a profile website), and
    // `new URL()` alone accepts `javascript:`, `data:` and the like, which then run on click.
    const formatUrl = (url) => {
        if (!url) return '';

        const safeUrl = toSafeHttpUrl(url);
        if (safeUrl) return safeUrl;
        if (typeof url !== 'string') return null;

        // A bare host such as `example.com` or `www.example.com/team` gets https://. Anything
        // that starts with another scheme (`javascript:`, `mailto:`, `ftp:`) is not a website
        // and is not linked. It is judged on the URL as a browser would read it, so a tab or
        // newline inside the scheme does not hide it. `example.com:8080` and `localhost:3000`
        // are a host and a port, not a scheme, so they still get https://.
        const cleaned = normalizeLikeBrowser(url);
        const hostAndPort = /^(localhost|[a-z0-9-]+(\.[a-z0-9-]+)+):\d+(?:[/?#]|$)/i;
        const startsWithScheme = /^[a-z][a-z0-9+.-]*:/i.test(cleaned) && !hostAndPort.test(cleaned);
        return startsWithScheme ? null : toSafeHttpUrl(`https://${cleaned}`);
    };

    const formattedUrl = formatUrl(href);

    // If URL is invalid, just render as text
    if (!formattedUrl) {
        return <span className={className} style={{...linkStyles}}>{children || href}</span>;
    }

    return (
        <a
            href={formattedUrl}
            className={className}
            style={{...linkStyles}}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Visit ${children || href} (opens in new tab)`}
        >
            {children || href}
        </a>
    );
};

export default ExternalLink;
